const combiningMarksRegex = /[\u0300-\u036f]/g;

export function normalizeSearchValue(value: string) {
	return value
		.toLocaleLowerCase()
		.normalize('NFD')
		.replace(combiningMarksRegex, '');
}
